/**
 * PLP collection card videos: defer preload until near viewport.
 * Poster still shows immediately; metadata fetch starts on intersection.
 */
(function () {
  if (window.__jiwyaCollectionCardVideoInit) return;
  window.__jiwyaCollectionCardVideoInit = true;

  function enablePreload(video) {
    if (video.dataset.collectionCardVideoReady === 'true') return;
    video.dataset.collectionCardVideoReady = 'true';
    video.preload = 'metadata';
    video.load();
  }

  function init() {
    var videos = document.querySelectorAll('video[data-collection-card-video]');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(enablePreload);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          enablePreload(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '120px 0px', threshold: 0.01 }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
